export const DIETS = '/api/v1/diets/for-parent';
export const DIET_CHILD = 'api/v1/diets/for-parent/childDiet';
